import { useMemo } from 'react';
export var createMemoizedContextData = function (data) { return useMemo(function () { return data; }, [data]); };
